import Footer from "@/components/footer/Footer";
import Navbar from "@/components/navbar/Navbar";
import React, { Suspense } from "react";



interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {

  return <Suspense>
      <Navbar/>
        {children}
      <Footer/>
    </Suspense>;
};
